import React from 'react'
import { Paper, useTheme } from '@mui/material'
import GppGoodIcon from '@mui/icons-material/GppGood'
import BoltIcon from '@mui/icons-material/Bolt'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'
import VerifiedIcon from '@mui/icons-material/Verified'
import Text from '../Text'

const BENEFITS = [
  {
    Icon: GppGoodIcon,
    title: 'Imunidade a banimento',
    description: 'Número protegido pelas políticas oficiais da Meta. Sem risco de bloqueio ou restrição como acontece no WhatsApp Web.',
  },
  {
    Icon: BoltIcon,
    title: 'Estabilidade total',
    description: 'Conexão direta com os servidores da Meta. Acabaram-se as desconexões e o trabalho de reescanear QR Code.',
  },
  {
    Icon: TrendingUpIcon,
    title: 'Alta entregabilidade',
    description: 'Templates aprovados pela Meta com maior taxa de entrega e leitura. Mensagens chegam com prioridade.',
  },
  {
    Icon: RocketLaunchIcon,
    title: 'Pronto para escalar',
    description: 'Tier de mensagens aumenta automaticamente conforme o uso. Volume alto sem travas nem throttle.',
  },
  {
    Icon: VerifiedIcon,
    title: 'Selo de verificação',
    description: 'Possibilidade de obter o selo verde oficial do WhatsApp Business, aumentando a credibilidade comercial do seu número.',
  },
]

function MetaOficialBenefits({ variant = 'card', heading = 'Por que migrar para a API Oficial' }) {
  const theme = useTheme()
  const isInline = variant === 'inline'

  const Wrapper = isInline ? 'div' : Paper
  const wrapperProps = isInline ? {} : { elevation: 2 }

  return (
    <Wrapper {...wrapperProps}>
      <div className={isInline ? '' : 'p-6'}>
        {heading && (
          <div className="mb-4">
            <Text className="text-base font-black uppercase tracking-wider">
              {heading}
            </Text>
            <div
              className="h-[3px] w-12 mt-2 rounded-full"
              style={{ backgroundColor: theme.palette.primary.main }}
            />
          </div>
        )}
        <div className="space-y-4">
          {BENEFITS.map(({ Icon, title, description }) => (
            <div key={title} className="flex items-start space-x-3">
              <div
                className="w-[36px] h-[36px] rounded-md flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${theme.palette.primary.main}1A` }}
              >
                <Icon style={{ fontSize: 22, color: theme.palette.primary.main }} />
              </div>
              <div className="flex-1">
                <Text className="text-sm font-black leading-tight">
                  {title}
                </Text>
                <Text className="text-xs font-light mt-0.5 leading-snug opacity-90">
                  {description}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Wrapper>
  )
}

export default MetaOficialBenefits
